// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__hgF1A","x2":"styles_x2__zeFF0","left":"styles_left__TWcD-","down":"styles_down__8zdiw","light":"styles_light__3r6-j","primary":"styles_primary__6FRsS"};